import React, { PureComponent } from 'react';
import { View, TouchableOpacity, ActivityIndicator, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H3, Large, H1 } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import Popover from '../../../../components/popover-component';
import { Info2, ChevronDown, ArrowRight, NotificationWarning, NotificationConfirmation } from '@dbk/ui-icons';
import Modal from '@dbk/ui-modal';
import { LoadingCircle } from '../../../../components/common/loading';
import { TextInput, Checkbox, Radio } from '@dbk/ui-forms';
import { Accordion, AccordionItem } from '@dbk/ui-accordion';


import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemFooter,
} from '@dbk/ui-list';
import ScrollTopOnMount from '../../../../components/common/scroll-top-on-mount'
import { PALETTE, ROUTES, CANADIAN_COUNTRY, EBANKINGWEBUK, RM_REGION_UK, CoP, WARNING_ICON, KEY_CODE} from '../../../../constants';
import { AccordionPlusIcon, AccordionMinusIcon, SuccessIcon } from '../../../../components/common/icons';
import SearchWithoutCircleIcon from '../../../../common/components/icons/search-without-circle';
import styles, { inactiveSVGStyles } from './payment-add-beneficiary.styles';

import Dropdown from '@dbk/ui-dropdowns';
import { isEqual, capitalize } from 'lodash';

import {
  validateBenefName,
  isEmpty,
  isCanadian,
  isCanadianError
} from '../utils';
import { convertToDropDown } from '../../payment-utils';
import PaymentError from '../../payment-error';
import { PAYMENT_TYPE } from '../../constant';
import { ErrorIcon } from '../../../../components/common/icons';
import envConfig from '../../../../../db-env-build';
class PymtBenefadd extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchBankModal: false,
      streetName: "",
      zipCode: "",
      country: "",
      bankName: "",
      sortCode: "",
      sortCodeValue: false,
      city: "",
      clearingNumber: "",
      postalCode: "",
      countrySelected: '',
      beneficiaryName: "",
      accountNumber: "",
      formattedAcntNumber: "",
      checkBeneficiaryName: false,
      isCountryEmpty: false,
      visible: false, // ??,
      duplicateBenfItem: {},
      isValidAccountNo: true,
      accountType: '',
      accountMatchType: '',
      isBeneficiaryValidated: false,
      beneficiaryConfirmationModal: false,
      CoPaccordionPartialMatchActive: [1],
      CoPaccordionNoMatchActive: [1],
      CoPaccordionNotApplicableActive: [1],
      accordionActive: this.props.payments.isPymtEditBenef ? [1] : []
    }
    this.searchCountry = this.searchCountry.bind(this);
    this.handleIconPress = this.handleIconPress.bind(this);

    
    
  }

  handleIconPress () {
    // eslint-disable-next-line no-alert
  
  }

  scrollLayout = e => this.refs.scrollView.scrollTo(e)

  componentWillUnmount() {
    this.props.payments.setErrorMsg(null);
    this.props.payments.setIsPymtEditBenef(false);
    this.props.payments.setIsPymtEditFrmCaptureScreen(false);
    this.props.payments.clearIBNErrorMsg('');
    this.props.payments.clearSortCodeErrorMsg('');
    this.props.payments.setAccountMatchType('');
    this.props.payments.setAccountTypeNoMatchType('');
    this.props.payments.setSearchBankLoading(false);
  }


  searchCountry(e) {
    const { country } = this.state;
    if((e && e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) || (!e)){
    if (!country) return;
    // todo: validate and trim
      if (country.length >= 2) {

        this.props.payments.getSearchCountryData({ country, isAllCountry: false })
          .then((success) => {
            this.setState({ visible: true })
          });
      }
    }
  }

  onBusinessTypeSelected = async (type) => {

    const { setSelectedBeneficiaryBank, setExistingBeneficiaryId, clearIBNErrorMsg, setAccountMatchType, resetDuplicateItem, setAccountTypeNoMatchType } = this.props.payments;
    await setSelectedBeneficiaryBank('');
    await resetDuplicateItem();
    await setExistingBeneficiaryId(null);
    await clearIBNErrorMsg('');
    await setAccountMatchType('');
    await setAccountTypeNoMatchType('');
    this.setState({accountType: type, isBeneficiaryValidated: false});
  }

  closeCountryModal = () => {
    this.setState({ visible: false });
  }
  closeSearchModal = () => {
    this.props.payments.clearIBNErrorMsg('');
    this.setState({ searchBankModal: false });
    this.props.payments.clearSortCodeErrorMsg('');
  }
  closeBeneficiaryConfirmationModal = () => {
    this.setState({ beneficiaryConfirmationModal: false });
  }
  handleCountryPress = val => {
    // const { country } = this.state;
    const { payments: { paymentType }, i18n: { messages } } = this.props;

    this.setState({
      country: val.countryName,
      visible: false
    });
    const isInternational = paymentType.includes(PAYMENT_TYPE.international);
    if (isInternational && isCanadian(val.countryName)) {
      this.props.payments.setErrorMsg(isCanadianError(messages['app.payment.beneficiary.canada.rule']));
    }
  }
  getBankDetails = async (type) => {
    const {
      isIBANSelected,
      paymentType,
      getBankAccountDetails,
      selectedBeneficiaryDetail
    } = this.props.payments;
    const {
      bankName,
      clearingNumber,
      city,
      postalCode,
      accountNumber,
      sortCode,
      countrySelected
    } = this.state;
    
    const forUKOnly = !!(envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic'));
    if(forUKOnly) {
      if(accountNumber.length === 7) {
        let accountNoFormatted = accountNumber;
        accountNoFormatted = '0' + accountNoFormatted;
        const targerObj = { 'target': { 'value' : accountNoFormatted}};
        await this.changeAccNumber(targerObj);
        }
      }
    
    if(selectedBeneficiaryDetail && selectedBeneficiaryDetail.country) {
      this.setState({countrySelected: selectedBeneficiaryDetail.country });
    }
    if (paymentType.includes('international') && !isIBANSelected && isEmpty(countrySelected)) {
      return this.setState({ isCountryEmpty: true })
    }
    getBankAccountDetails({
      searchTermBankName: bankName || '',
      searchTermNtnlId: clearingNumber || '',
      searchTermCity: city || '',
      searchTermPostalCode: postalCode || countrySelected,
      ibanOrAccountNo: accountNumber || '',
      isIBAN: isIBANSelected || '',
      sortCode: sortCode ? sortCode.split('-').join('').toString():''
    });
    this.setState({
      searchBankModal: type === 'SEARCH',
      isCountryEmpty: false
    })
  }
  // todo: iban
  handleIbanCheckbox = () => {
    const {
      setIBAN,
      isIBANSelected,
      setSelectedBeneficiaryBank,
      setExistingBeneficiaryId,
      clearSortCodeErrorMsg,
      clearIBNErrorMsg,
      setAccountMatchType,
      setAccountTypeNoMatchType
    } = this.props.payments
    setIBAN(!isIBANSelected);
    setSelectedBeneficiaryBank(null);
    setExistingBeneficiaryId(null);
    clearSortCodeErrorMsg('');
    clearIBNErrorMsg('');
    setAccountMatchType('');
    setAccountTypeNoMatchType('');
    this.setState({accountType: '', sortCode:"", formattedAcntNumber:"", isValidAccountNo: true});

  }
  handleBankRowPress = (row, e) => {
    const {
      setSelectedBeneficiaryBank,
      setSelectedBank,
      paymentType
    } = this.props.payments;
    const {
      i18n: { messages }
    } = this.props;
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      row.ibanSearchedAddress = row.address1;
      setSelectedBank(row);
      setSelectedBeneficiaryBank(row);
      const isInternational = paymentType.includes(PAYMENT_TYPE.international);
      if (isInternational && isCanadian(row.country)) {
        this.setState({
          accordionActive: [1]
        })
        this.props.payments.setErrorMsg(isCanadianError(messages['app.payment.beneficiary.canada.rule']));
      }
      this.setState({
        searchBankModal: false,
        bankName: "",
        city: "",
        clearingNumber: "",
        postalCode: "",
      });
    }
  }


  // Function to get the add/edit beneficiary details
  getSelectedBenf = () => {
    const {
      beneficiaryName,
      accountNumber,streetName, zipCode, country, accountType, sortCode
    } = this.state;
    let {
      selectedBeneficiaryDetail,
      selectedBeneficiaryBank,
      setSelectedBeneficiaryBank, isIBANSelected,
      setIsPymtAddNewBenef
    } = this.props.payments;
    let {
      i18n: { messages }
    } = this.props;

    let modifiedSelectedBeneficiaryBank = Object.assign({},selectedBeneficiaryBank);
    //fix for WMCE-6278
    let firstName = '';
    let lastName = '';
    let benefName = beneficiaryName;
    if (benefName.indexOf(' ') == -1) {
      firstName = benefName;
    } else if (benefName.indexOf(' ') == 0) {
      firstName = benefName
    } else {
      firstName = benefName.substr(0, benefName.indexOf(' '));
      lastName = benefName.substr(benefName.indexOf(' ') + 1);
    }
    if(selectedBeneficiaryDetail) {
      if(selectedBeneficiaryDetail.beneficiaryId) {
        modifiedSelectedBeneficiaryBank.beneficiaryId = selectedBeneficiaryDetail.beneficiaryId;
      }
    }
      
    modifiedSelectedBeneficiaryBank.beneficiaryName = benefName;
    modifiedSelectedBeneficiaryBank.firstName = firstName;
    modifiedSelectedBeneficiaryBank.lastName = lastName;
    if (isIBANSelected) {
      modifiedSelectedBeneficiaryBank.ibanNo = accountNumber;
      modifiedSelectedBeneficiaryBank.accountNo = null;
      modifiedSelectedBeneficiaryBank.sortCode = null;
    } else {
      modifiedSelectedBeneficiaryBank.accountNo = accountNumber;
      modifiedSelectedBeneficiaryBank.ibanNo = null;
      modifiedSelectedBeneficiaryBank.sortCode = sortCode;
      modifiedSelectedBeneficiaryBank.accountType = selectedBeneficiaryBank.businessType || accountType;
    }
    modifiedSelectedBeneficiaryBank.address1 = streetName;
    modifiedSelectedBeneficiaryBank.address2 = zipCode;
    modifiedSelectedBeneficiaryBank.address3 = country;
    return modifiedSelectedBeneficiaryBank;
  }

  addBeneficiary() {
    const {payments: {paymentType, isIBANSelected, accountMatchType} } = this.props;
    if((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes('domestic') && !isIBANSelected){
      if( (accountMatchType === CoP.MATCH) || (accountMatchType === CoP.NO_MATCH) || (accountMatchType === CoP.PARTIAL_MATCH) || (accountMatchType === CoP.NOT_APPLICABLE) ) {  //WMCE-48072-Adding confirmation Alert for COP match 
        this.setState({beneficiaryConfirmationModal: true});
      }
      else {
        this.navigateToForm();
      }
    } else {
      this.navigateToForm();
    }
  }

  objectcleaningwithNoValue = (inputObj) => {
    for (const property in inputObj) {
      if(!inputObj[property]) {
        inputObj[property] = '';
      }
      if((property == 'sortCode') || (property == 'ntnlId')) {
        if(inputObj[property]) {
          inputObj[property] = inputObj[property].replaceAll("-", "");
        }
      }
    }
    return inputObj;
  }

  // Action handler for Beneficiary confirmation
  navigateToForm() {
    let { beneficiaryIdToUpdate, isPymtEditBenef, isPymtEditFrmCaptureScreen, selectedBeneficiaryDetail, setSelectedBeneficiaryBank, selectedBeneficiaryBank } = this.props.payments;
    //fix for WMCE-6278
    let modifiedSelectedBeneficiaryBank = this.getSelectedBenf();

        if (isPymtEditBenef || isPymtEditFrmCaptureScreen) {

          let newSelectedBeneficiaryBank = this.objectcleaningwithNoValue(selectedBeneficiaryBank);
          let newModifiedSelectedBeneficiaryBank = this.objectcleaningwithNoValue(modifiedSelectedBeneficiaryBank);

              if (isEqual(newSelectedBeneficiaryBank, newModifiedSelectedBeneficiaryBank)) {
                // if user has not edited anything, dont call the update API
                this.props.changePage(isPymtEditBenef ? ROUTES.PAYMENT.DESTINATION : ROUTES.PAYMENT.NEW_DOMESTIC);
                return;
              }
              if(beneficiaryIdToUpdate) {
                modifiedSelectedBeneficiaryBank.beneficiaryId = beneficiaryIdToUpdate;
              } else {
                modifiedSelectedBeneficiaryBank.beneficiaryId = modifiedSelectedBeneficiaryBank.beneficiaryId || selectedBeneficiaryDetail.beneficiaryId;
              }
              modifiedSelectedBeneficiaryBank.lastAccessed = modifiedSelectedBeneficiaryBank.lastAccessed || selectedBeneficiaryDetail.lastAccessed;
              setSelectedBeneficiaryBank(modifiedSelectedBeneficiaryBank);
              this.props.payments.addNewBeneficiary();
            } else {
              // add new beneficiary
              setSelectedBeneficiaryBank(modifiedSelectedBeneficiaryBank);
              this.props.payments.addNewBeneficiary();
            }

  }

  newBankSearch = (e) => {
    const {
      setIBAN,
      setSelectedBeneficiaryBank,
      setExistingBeneficiaryId,
      clearSortCodeErrorMsg,
      setAccountMatchType,
      setAccountTypeNoMatchType
    } = this.props.payments;
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){ 
      setIBAN(false);
      setAccountMatchType('');
      setAccountTypeNoMatchType('');
      setExistingBeneficiaryId(null);
      setSelectedBeneficiaryBank(null);
      clearSortCodeErrorMsg('');
      this.setState({sortCode: '' });
      this.props.payments.setErrorMsg(null);
    }
   
  }

  renderCountryModal = countryList => {
    const { i18n: { messages } } = this.props;
    return (
      <View>
        {countryList && countryList.length > 0 &&
          <Modal
            isActive={this.state.visible} 
            style={styles.modalstyle}
            onClose={this.closeCountryModal}
            content={
              <div className="columns small-12 small-centered">
                <div className="row" style={StyleSheet.flatten(styles.modalRow)}>
                  <H3 tabIndex={0} style={StyleSheet.flatten(styles.modalHeading)}>{messages['app.payments.selectCountry']}</H3>
                </div>
                <hr />
                <View style={StyleSheet.flatten(styles.modalContent)}>
                  <div testID="payment-country">
                    <View style={styles.modalstyle}>
                      {countryList.map(val => (
                        <TouchableOpacity
                          key={countryList.isocode || countryList.countryName}
                          onPress={() => this.handleCountryPress(val)}>
                          <View style={styles.modalRow}>
                            <View style={styles.modalRowLeft}>
                              <Text>{val.countryName}</Text>
                            </View>
                          </View>
                        </TouchableOpacity>)
                      )}
                    </View>
                  </div>
                </View>
              </div>
            } />
        }
      </View>)
  }
  // render optional address logic
  _renderHeader = () => {
    const { messages } = this.props.i18n;
    const { payments: { paymentType, selectedCurrency, selectedBeneficiaryBank } } = this.props;
    const isInternational = paymentType.includes(PAYMENT_TYPE.international);

    const addrMandatory = isInternational && (isCanadian(this.state.country) || (selectedCurrency && selectedCurrency.tech === CANADIAN_COUNTRY.currencyCode) ||
      (selectedBeneficiaryBank && isCanadian(selectedBeneficiaryBank.country)));

    return <span>
      <Large style={StyleSheet.flatten(styles.label)} aria-label={messages['app.payment.beneDetail.address']} >{messages['app.payment.beneDetail.address']}</Large>
      {addrMandatory ? <span style={StyleSheet.flatten(styles.asteriskStyle)}>*</span> : <Large style={StyleSheet.flatten(styles.label)} aria-label={messages['app.payment.beneDetail.address.optional']}>{messages['app.payment.beneDetail.address.optional']}</Large>}
    </span>
  }

  // CoP Match Header
  renderCoPMatchHeader = () => {
    const { messages } = this.props.i18n;
    return(
      <div className="row">
        <div className='column' style={{width: '5%'}}>
          <NotificationConfirmation width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />
        </div>
        <div className='column' style={StyleSheet.flatten([styles.noPaddingLeft, styles.autoWidth, styles.leftFloat])}>
          <Text style={StyleSheet.flatten(styles.partialMatchLabel)}>{messages['app.CoP.label.AccountMatch.header']}</Text>
        </div>
      </div>    
    );
  }

  onCountryChange = (target) => {
    this.setState({ country: target });
    const { payments: { paymentType }, i18n: { messages } } = this.props;

    const isInternational = paymentType.includes(PAYMENT_TYPE.international);
    if (isInternational && isCanadian(target)) {
      this.props.payments.setErrorMsg(isCanadianError(messages['app.payment.beneficiary.canada.rule']));
    }else{
      this.props.payments.setErrorMsg("");
    }
  }
    // CoP No Match Header
    renderCoPNoMatchHeader = () => {
      const { messages } = this.props.i18n;
      return (
        <View>
          <div className="row">
            <div className='column' style={{width: '5%'}}>
              <NotificationWarning width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />
            </div>
            <div className='column' style={StyleSheet.flatten([styles.noPaddingLeft, styles.autoWidth, styles.leftFloat])}>
              <Text style={StyleSheet.flatten(styles.partialMatchLabel)} role="alert" tabIndex={0}>{messages['app.CoP.label.NoMatch.header']}</Text>
            </div>
          </div>    
        </View>
      );
    }
  
    // CoP Partial Match Header
    renderCoPPartialMatchHeader = () => {
      const { messages } = this.props.i18n;
      return (
        <View>
          <div className="row">
            <div className='column' style={{width: '5%'}} >
            <NotificationWarning width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />
            </div>
            <div className='column' style={StyleSheet.flatten([styles.noPaddingLeft, styles.autoWidth, styles.leftFloat])}>
              <Text style={StyleSheet.flatten(styles.partialMatchLabel)} role="alert" tabIndex={0}>{messages['app.CoP.label.partialMatch.header']}</Text>
            </div>
          </div>    
        </View>
      );
    }

    // CoP Account Type No Match Header
    renderAccountTypeNoMatchHeader = () => {
      const { messages } = this.props.i18n;
      return (
        <View>
          <div className="row">
            <div className='column' style={{width: '5%'}} >
            <NotificationWarning width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />
            </div>
            <div className='column' style={StyleSheet.flatten([styles.noPaddingLeft, styles.autoWidth, styles.leftFloat])}>
              <Text style={StyleSheet.flatten(styles.partialMatchLabel)} role="alert" tabIndex={0}>{messages['app.CoP.label.accountTypeNoMatch.header']}</Text>
            </div>
          </div>    
        </View>
      );
    }

    // CoP Not Applicable Header
    renderCoPNotApplicableHeader = () => {
      const { messages } = this.props.i18n;
      return (
        <View>
          <div className="row">
            <div className='column' style={{width: '5%'}}>
              <NotificationWarning width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />
            </div>
            <div className='column large-11' style={StyleSheet.flatten([styles.noPaddingLeft, styles.leftFloat])}>
              <Text style={StyleSheet.flatten(styles.partialMatchLabel)} role="alert" tabIndex={0}>
                {messages['app.CoP.label.notApplicable.header']}
              </Text>
            </div>
          </div>    
        </View>
      );
    }

    // CoP Partial Match content
    renderCoPPartialMatchContent = () => {
      const { messages } = this.props.i18n;
      return (
      <View>
        <div className='row'>
          
          <div className='column' style={StyleSheet.flatten(styles.leftmargin5per)}>
            <div className='row'>
              <div className='column small-3' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.CoP.label.partialMatch.nameEntered']}
              </div>
              <div className='column small-9' style={StyleSheet.flatten(styles.partialMatchLabel)}>
                {this.state.beneficiaryName}
              </div>
            </div>
  
            <div className='row' style={StyleSheet.flatten(styles.paddignTop10)}>
              <div className='column small-3' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.CoP.label.partialMatch.accountNameAtBeneficiaryBank']}
              </div>
              <div className='column small-9' style={StyleSheet.flatten(styles.partialMatchLabel)}>
                {this.props.payments.CoPAccountNameMatched}
              </div>
            </div>
  
            <div className='row' style={StyleSheet.flatten(styles.paddignTop10)}>
              <div className='column small-3' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.CoP.label.partialMatch.couldBeFraudOrScam']}
              </div>
            </div>
  
            <div className='row' style={StyleSheet.flatten(styles.partialMatchLabel)}>
              {messages['app.CoP.label.partialMatch.contactAndEnsureBeneficiary.Text']}
            </div>
  
            <div className='row' style={StyleSheet.flatten(styles.partialMatchLabel)}>
              {messages['app.CoP.label.partialMatch.EditBeneficiaryText']}
            </div>
  
            <div className='row' style={StyleSheet.flatten([styles.partialMatchLabel, styles.paddignTop10])}>
              {messages['app.CoP.label.partialMatch.couldBeFraudOrScam.warning']}
            </div>
          </div>
        </div>
        
      </View>
      );
    }

  // CoP Not Applicable Content
  renderCoPNotApplicableContent = () => {
    const { messages } = this.props.i18n;
    return (
      <View>
        <div className='row'>
          <div className='column small-11' style={StyleSheet.flatten(styles.leftmargin5per)}>
            <div className='row'>
              <div className='column small-12' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.CoP.label.NotApplicable.content']}
              </div>
            </div>
          </div>   
       </div>
      </View>
    )
  }

  // CoP No Match content
  renderCoPNoMatchContent = () => {
    const { messages } = this.props.i18n;
    return (
      <View>
        <div className='row'>
          <div className='column small-11' style={StyleSheet.flatten(styles.leftmargin5per)}>
            <div className='row'>
              <div className='column small-12' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.CoP.label.NoMatch.detailsEntered']}
              </div>
            </div>

            <div className='row' style={StyleSheet.flatten(styles.paddignTop10)}>
              <div className='column small-2' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.CoP.label.NoMatch.accountName']}
              </div>
              <div className='column small-10' style={StyleSheet.flatten(styles.partialMatchLabel)}>
                {this.state.beneficiaryName}
              </div>
            </div>

            <div className='row' style={StyleSheet.flatten(styles.paddignTop10)}>
              <div className='column small-2' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.CoP.label.NoMatch.accountNumber']}
              </div>
              <div className='column small-10' style={StyleSheet.flatten(styles.partialMatchLabel)}>
                {this.state.accountNumber}
              </div>
            </div>

            <div className='row' style={StyleSheet.flatten(styles.paddignTop10)}>
              <div className='column small-2' style={StyleSheet.flatten([styles.partialMatchLabel, styles.noPaddingLeft])}>
                {messages['app.payment.beneDetail.sortcodeLabel']}
              </div>
              <div className='column small-10' style={StyleSheet.flatten(styles.partialMatchLabel)}>
                {this.state.sortCode}
              </div>
            </div>

            <div className='row' style={StyleSheet.flatten([styles.partialMatchLabel, styles.paddignTop10])}>
              {messages['app.CoP.label.partialMatch.contactAndEnsureBeneficiary.Text']}
            </div>

            <div className='row' style={StyleSheet.flatten(styles.partialMatchLabel)}>
              {messages['app.CoP.label.partialMatch.EditBeneficiaryText']}
            </div>

            <div className='row' style={StyleSheet.flatten([styles.partialMatchLabel, styles.paddignTop10])}>
              {messages['app.CoP.label.NoMatch.loseMoneyWarning']}
            </div>
          </div>   
       </div>
      </View>
    )
  }

  onCountryChange = (target) => {
    this.setState({ country: target });
    const { payments: { paymentType }, i18n: { messages } } = this.props;

    const isInternational = paymentType.includes(PAYMENT_TYPE.international);
    if (isInternational && isCanadian(target)) {
      this.props.payments.setErrorMsg(isCanadianError(messages['app.payment.beneficiary.canada.rule']));
    }
  }

  _renderContent = row => {
    const { i18n: { messages }, payments: { countryList } } = this.props;
    const {
      streetName,
      zipCode,
      country
    } = this.state;
    return (
      <View className="accordionContent" >
        <div className="row">
          <div className="columns large-1 large-12">
            <TextInput
              ref='textRef'
              className="textInputAccordian"
              placeholder={messages['app.payment.beneDetail.streetName']}
              maxLength={35}
              onChange={(streetName) => this.setState({ streetName: streetName.target.value })}
              style={StyleSheet.flatten(styles.inputSpacing)}
              value={streetName}
              tabIndex={this.state.accordionActive.length===0 ? "-1" : "0"}
            />
          </div>
        </div>
        <div className="row">
          <div className="columns large-1 large-12">
            <TextInput
              ref='textRef'
              className="textInputAccordian"
              placeholder={messages['app.payment.beneDetail.zipCode']}
              maxLength={35}
              onChange={(zipCode) => this.setState({ zipCode: zipCode.target.value })}
              value={zipCode}
              tabIndex={this.state.accordionActive.length===0 ? "-1" : "0"}
            />
          </div>
        </div>
        <div className="row">
          <div className="columns large-1 large-12">
            <TextInput
              ref='textRef'
              className="textInputAccordian"
              placeholder={messages['app.payment.country']}
              onChange={(country) => this.onCountryChange(country.target.value)}
              value={country}
              tabIndex={this.state.accordionActive.length===0 ? "-1" : "0"}
            />
            {/* <TouchableOpacity
              style={styles.countryBtn}
              onPress={this.searchCountry} 
              tabIndex="-1"
              > */}
              <div style={{right: 5, position: 'absolute', top: 18, marginTop: 113, marginRight: 30, paddingHorizontal: 10, cursor:'pointer'}}
                onClick={()=>this.searchCountry()} 
                onKeyDown={(e)=>this.searchCountry(e)}
                tabIndex={this.state.accordionActive.length===0 ? "-1" : "0"}
                aria-label={messages['app.payment.beneDetail.searchBank']}
                role="button">
              <SearchWithoutCircleIcon width={20} height={20} fill={inactiveSVGStyles.color} />
              </div>
            {/* </TouchableOpacity> */}
            {this.props.payments.noRecordsFound && <View><Large style={StyleSheet.flatten(styles.noCountryRecord)}>{messages['app.reports.noRecords']}</Large></View>}
          </div>
        </div>
      </View>
    );
  };

  renderBeneficiaryConfirmModal = () => {
    const { i18n: { messages }, payments: { accountMatchType } } = this.props;
    return (
      <Modal
        testID="modal_beneficiaryConfirmation_Modal_test"
        className="beneficiary-confirm-modal"
        isActive={this.state.beneficiaryConfirmationModal}
        style={styles.modalstyle}
        onClose={this.closeBeneficiaryConfirmationModal}
        header={messages['app.payment.CoP.Confirm.Modal.header']}
        content={
          <div style={StyleSheet.flatten(styles.padding20)}>
            <div className="row" style={StyleSheet.flatten([styles.paddignTop10, styles.beneficiaryConfirModal])}>
              { accountMatchType === CoP.MATCH ? messages['app.payment.CoP.Confirm.modal.perfectMatch.sureToContinue'] :accountMatchType === CoP.PARTIAL_MATCH ? messages['app.payment.CoP.Confirm.modal.partialMatch.sureToCintinue'] : messages['app.payment.CoP.Confirm.modal.sureToCintinue'] }
           </div>
            <div className="row" style={StyleSheet.flatten([styles.paddignTop10, styles.PB20, styles.beneficiaryConfirModal])}>
              {(accountMatchType !== CoP.MATCH) && messages['app.payment.CoP.Confirm.modal.incorrectAccountWarning']}
            </div>
            <div className='row' style={StyleSheet.flatten(styles.PT20)}>
              <div className='columns' style={StyleSheet.flatten([styles.autoWidth, styles.rightFloat])}>
                <Button
                    testID="btn_payment_CoP_paymentAddBeneficiary_Contine_test"
                    size="normal"
                    onPress={() => this.navigateToForm()}
                  >
                  {messages['app.profile.consolidatesetup.cont']}
                </Button>
              </div>
              <div className='columns' style={StyleSheet.flatten([styles.autoWidth, styles.rightFloat])}>
                <Button
                  tertiary
                    testID="btn_payment_CoP_paymentAddBeneficiary_Contine_test"
                    size="normal"
                    onPress={() => this.closeBeneficiaryConfirmationModal()}
                    style={StyleSheet.flatten(styles.cancelButton)}
                  >
                  {messages['app.chedelivery.reports.customReports.cancelButton']}
                </Button>
              </div>
              <div className='columns large-3'></div>
            </div>
          </div>
          
        } />

    );

  }

  _renderSearchModal = data => {
    const { i18n: { messages }, payments: { searchBankLoading, errorIBANMsg, paymentType } } = this.props;
    return (
      <Modal
        testID="modal_beneficiaryDetails_paymentAddBeneficiary_test"
        isActive={this.state.searchBankModal}  // disabling it as we are working with static data
        // isActive={false}
        className="focusSearchDestBank"
        style={styles.modalstyle}
        onClose={this.closeSearchModal}
        header={messages['app.payment.beneDetail.destinationBank']}
        content={
          <div className="columns large-1 large-12 small-centered">
            <div style={StyleSheet.flatten(styles.modalContent)}>
              {searchBankLoading &&
                <div>
                  <ActivityIndicator
                    style={StyleSheet.flatten(styles.activityLoader)}
                    animating
                    color={PALETTE.primaryText}
                    size="large"
                  />
                </div>}
              {!searchBankLoading && errorIBANMsg && this.renderErrorMsg()}
              {!searchBankLoading && !errorIBANMsg && data && data.length && data.map(val => (
                <NavigationListItem tabIndex={0}
                  testID="list_beneficiaryDetailsModal_paymentAddBeneficiary_test"
                  style={{backgroundColor:'#000e28'}}
                  key={data.ntnlId}
                  onKeyDown={(e) => this.handleBankRowPress(val, e)}
                  onClick={() => this.handleBankRowPress(val)}>
                  <NavigationListItemFooter className="white-all">{val.bank}</NavigationListItemFooter>
                  {/international/i.test(paymentType)
                    ? <NavigationListItemFooter className="grey-all" color={PALETTE.primaryText}>{val.swiftCode}</NavigationListItemFooter>
                    : <NavigationListItemFooter className="grey-all" color={PALETTE.primaryText}>{val.ntnlId}</NavigationListItemFooter>
                  }
                  <NavigationListItemFooter className="grey-all" color={PALETTE.primaryText}>{val.address1 != null && val.address1}</NavigationListItemFooter>
                  <NavigationListItemFooter className="grey-all" color={PALETTE.primaryText}>{(val.city ? val.city : '') + (val.postalCode && val.city ? (', ' + val.postalCode) : (val.postalCode ? val.postalCode : ''))}</NavigationListItemFooter>
                  <NavigationListItemFooter className="grey-all" color={PALETTE.primaryText}>{/international/i.test(paymentType) ? val.country : ''}</NavigationListItemFooter>
                </NavigationListItem>
              ))}
            </div>
          </div>
        } />
    );
  };

  renderErrorMsg = () => {
    const errorMsg = this.props.payments.errorIBANMsg;
    const sortCodeError = this.props.payments.errorSortCodeMsg;
    return errorMsg ? <Text style={{'color':'red'}} aria-label={errorMsg} role="alert" tabIndex={0}>{errorMsg}</Text> : <Text style={{'color':'red'}} aria-label={errorMsg} role="alert">{sortCodeError}</Text>
  }

  renderInvalidAccountErrorMsg = () => {
    const { i18n: { messages } } = this.props;
    return <Text style={{'color':'red'}} role="alert" tabIndex={0}> {messages['app.payment.beneficiary.invalidActNo']}</Text>
  }
  handleCountrySelect = country => {
    this.setState({ postalCode: country, countrySelected: country, isCountryEmpty: false });
  }

  changeAccNumber = async accountNumber => {
    const { target: { value } } = accountNumber;
    const { payments: { setSelectedBeneficiaryBank, setIsPymtEditBenef, resetDuplicateItem, paymentType, isIBANSelected, setExistingBeneficiaryId } } = this.props;
    let valUpperCase = value.toUpperCase().replace(/\s/g, '');
    if(valUpperCase.length < 7 ) {
      this.setState({ isValidAccountNo : false});
    } else {
      this.setState({ isValidAccountNo : true});
    }
    // Accept only no.s for UK Domestic Sort code flow
    if(envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic') && !isIBANSelected){
      valUpperCase = valUpperCase.replace(/\D+/g, '');
    }
    const formattedAccountNo = valUpperCase.replace(/(.{4})/g, '$1 ').trim();
    const regEx = /^[a-z\d\-_\s]+$/i;
    await setSelectedBeneficiaryBank(null);
    if(envConfig.envConfig === EBANKINGWEBUK){
        if(regEx.test(formattedAccountNo) || formattedAccountNo ==='' ){
          
          await this.props.payments.setAccountMatchType('');
          await this.props.payments.setAccountTypeNoMatchType('');
          await resetDuplicateItem();
          await setExistingBeneficiaryId(null);
          this.setState({ accountNumber: valUpperCase, formattedAcntNumber: formattedAccountNo, isBeneficiaryValidated: false, countrySelected:'' });
        }
    }else{
      setExistingBeneficiaryId(null);
      await setIsPymtEditBenef(false);
      await resetDuplicateItem();
      this.setState({ accountNumber: valUpperCase, formattedAcntNumber: formattedAccountNo, isBeneficiaryValidated: false, countrySelected:'' });

    }
      
  }

  onKeyUpSortCode = async (e) => {
    const key  = e.key;
    const keyCode = e.keyCode;
    const {payments: { resetDuplicateItem, setExistingBeneficiaryId, setAccountMatchType, setSelectedBeneficiaryBank, clearSortCodeErrorMsg, setAccountTypeNoMatchType } } = this.props;
    const { sortCode } = this.state;

    const numberRegex = new RegExp('^[0-9]+$');
    const isNumber = numberRegex.test(key);

    const sortCodeArray = sortCode.split("-");
    const lastSortCodeBlock = sortCodeArray[sortCodeArray.length-1];

    if(sortCode.length < 8) {

      if( (sortCodeArray.length < 4)) {
        // Number is entered
        if(isNumber) {
          if(lastSortCodeBlock.length === 0 || (lastSortCodeBlock.length === 1) ) {
            await clearSortCodeErrorMsg('');
            await setSelectedBeneficiaryBank(null);
            await setAccountMatchType('');
            await setAccountTypeNoMatchType('');
            await setExistingBeneficiaryId(null);
            await resetDuplicateItem();
            this.setState({sortCode : `${sortCode}${key}`, isBeneficiaryValidated: false});


          }
         else if( (lastSortCodeBlock.length === 2) && (sortCodeArray.length < 3) ) {
            await clearSortCodeErrorMsg('');
            await setSelectedBeneficiaryBank(null);
            await setAccountMatchType('');
            await setAccountTypeNoMatchType('');
            await resetDuplicateItem();
            this.setState({sortCode : `${sortCode}-${key}`, isBeneficiaryValidated: false});


          } 
        }
      }



      // Space bar OR Hyphen is entered
      // keyCode = 32 [ Space bar ]
      // keyCode = 189 [ Hyphen or Dash ]
      if( (keyCode ===  32) || (keyCode === 189 ) ){

        if( (sortCodeArray.length < 4)) {

          if(lastSortCodeBlock.length === 1 ) {
            const lastNumber = sortCode[sortCode.length - 1];
            let newSortCode = sortCode.slice(0,sortCode.length - 1);
            newSortCode = `${newSortCode}0${lastNumber}`;
            await clearSortCodeErrorMsg('');
            await setSelectedBeneficiaryBank(null);
            await setAccountMatchType('');
            await setAccountTypeNoMatchType('');
            await setExistingBeneficiaryId(null);
            await resetDuplicateItem();
            this.setState({sortCode : newSortCode, isBeneficiaryValidated: false});
          }
        }
      }
    }

    // Backspace entered
    // keyCode = 8 [ Back-Space ]
    if(keyCode === 8 ) {
      if(sortCode[sortCode.length-2] === "-") {
        await setSelectedBeneficiaryBank(null);
        await setAccountMatchType('');
        await setAccountTypeNoMatchType('');
        await setExistingBeneficiaryId(null);
        await resetDuplicateItem();
        this.setState({sortCode : sortCode.slice(0,sortCode.length-2), isBeneficiaryValidated: false});

        
      } else {
        await setSelectedBeneficiaryBank(null);
        await setAccountMatchType('');
        await setAccountTypeNoMatchType('');
        await setExistingBeneficiaryId(null);
        await resetDuplicateItem();
        this.setState({
          sortCode : sortCode.slice(0,sortCode.length-1), 
          isBeneficiaryValidated: false
        });
      }
      await this.props.payments.clearSortCodeErrorMsg('');
     
    }
  }

  _renderDestinationBank = () => {
    const {
      i18n: { messages },
      payments: {
        selectedBeneficiaryBank,
        isIBANSelected,
        searchBankLoading,
        paymentType,
        allCountryList,
        selectedBeneficiaryDetail
      },
    } = this.props;
    const {
      bankName,
      clearingNumber,
      city,
      postalCode,
      isCountryEmpty,
      sortCode,
      sortCodeValue,
      isSixDigitSortCode,
      countrySelected
    } = this.state;
    const isInternational = paymentType.includes('international');
    const isSepa = paymentType.includes('sepa');
    const isSearchEnable = !isEmpty(bankName) || !isEmpty(clearingNumber) || !isEmpty(city) || !isEmpty(postalCode);
    const countryList = convertToDropDown(allCountryList, ['countryName', ''], "");
    const isUKDomestic = envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic') ? true : false
    const isDomesticPayment = paymentType.includes('domestic');

      if (searchBankLoading) {
        return (
          <View style={StyleSheet.flatten(styles.destActivityLoader)}>
            <ActivityIndicator
              animating
              color={PALETTE.primaryText}
              size="large"
            />
          </View>
        )
      }
      if (!searchBankLoading && selectedBeneficiaryBank) {
      let ntnlIdFormat='';
      if(isUKDomestic && !isIBANSelected && selectedBeneficiaryBank.ntnlId){
          let  sortCode =  selectedBeneficiaryBank.ntnlId ;
          ntnlIdFormat = `${sortCode.slice(0,2)}-${sortCode.slice(2,4)}-${sortCode.slice(4,6)}`
      }else if (isDomesticPayment){
        ntnlIdFormat  = selectedBeneficiaryBank.ntnlId;
      }
      return (
        <View style={styles.beneNameFieldDestination} id="text_bankDetails_paymentAddBeneficiary_test">
          <Large style={StyleSheet.flatten(styles.label)} testID="text_destinationBank_paymentAddBeneficiary_test" tabIndex={0}> {messages['app.payment.beneDetail.destinationBank']} </Large>
          <Text secondary tabIndex={0}>{selectedBeneficiaryBank.bank}</Text>
          {isDomesticPayment
            ? <Text secondary tabIndex={0}>{ntnlIdFormat}</Text>
            : <Text secondary tabIndex={0}>{selectedBeneficiaryBank.swiftCode}</Text>
          }
          <Text secondary tabIndex={selectedBeneficiaryBank.ibanSearchedAddress?"0":"-1"}>{selectedBeneficiaryBank.ibanSearchedAddress}</Text>
          <Text secondary tabIndex={selectedBeneficiaryBank.city || selectedBeneficiaryBank.cityName || selectedBeneficiaryBank.postalCode ? "0" : "-1"}>{selectedBeneficiaryBank.city || selectedBeneficiaryBank.cityName}{selectedBeneficiaryBank.postalCode && (', ' + selectedBeneficiaryBank.postalCode)}</Text>
          {(isInternational || isSepa) &&
            (<Text secondary tabIndex={selectedBeneficiaryBank.country?"0":"-1"}>{selectedBeneficiaryBank.country}</Text>)
          }
          <div>
            {
              !isSepa && !isUKDomestic && <View onClick={() => this.newBankSearch()} style={styles.inlineButton}>
                <Text tabIndex={0} onKeyDown={(e) => this.newBankSearch(e)} className="payment-search-inline" style={{ color: PALETTE.primaryActive }} id="text_newBankSearch_paymentAddBeneficiary_test" role="link"> {messages['app.payment.beneDetail.newSearch']} </Text>
              </View>
            }
          </div>
        </View>
      )
    }

    return (
      <View style={styles.beneNameFieldDestination}>
        {!isIBANSelected &&
          <div className="row" >
            {(envConfig.envConfig !== EBANKINGWEBUK || !paymentType.includes(PAYMENT_TYPE.domestic)) &&
              <div className="columns large-1 large-6">
                <Large style={StyleSheet.flatten(styles.label)} tabIndex={0}>{messages['app.payment.beneDetail.destinationBank']} </Large>
                <TextInput
                  ref='bankName'
                  className="textInputAccordian"
                  placeholder={messages['app.payment.beneDetail.bankName']}

                  onSubmitEditing={(event) => { this.refs.textRef.blur(); }}
                  onChange={(bankName) => this.setState({ bankName: bankName.target.value, isBeneficiaryValidated: false })}
                  value={bankName}
                  id="input_beneficiaryDetails_bankName_paymentAddBeneficiary_test"
                // onFocus={(e) => this.scrollLayout(180)}
                />
                <TextInput
                  ref='clearingNumber'
                  className="textInputAccordian"
                  placeholder={isInternational ?
                    messages['app.payment.beneDetail.swiftCode'] :
                    messages['app.payment.beneDetail.clearingNumber']}
                  onChange={(clearingNumber) => this.setState({ clearingNumber: clearingNumber.target.value })}
                  style={StyleSheet.flatten(styles.inputSpacing)}
                  value={clearingNumber}
                  id="input_beneficiaryDetails_clearingNumber_paymentAddBeneficiary_test"
                // onFocus={(e) => this.scrollLayout(250)}
                />
                <TextInput
                  ref='city'
                  className="textInputAccordian"
                  placeholder={messages['app.payment.beneDetail.city']}
                  onChange={(city) => this.setState({ city: city.target.value })}
                  style={StyleSheet.flatten(styles.inputSpacing)}
                  value={city}
                  id="input_beneficiaryDetails_city_paymentAddBeneficiary_test"
                // onFocus={(e) => this.scrollLayout(310)}
                />
                {isInternational ?
                  <div className="payment-filter-input" aria-label={messages['app.payment.countryDropdown']}>
                    {isCountryEmpty && <Text className="benTxtInputError" tabIndex={0} role="alert">{messages['app.payments.dropdown.select']}</Text>}
                    <Dropdown 
                      className='customDropDownFilter'
                      size='large'
                      fullwidth
                      selected={countrySelected}
                      options={countryList}
                      defaultLabel={messages['app.payments.selectCountry']}
                      onChange={(option) => {
                        this.handleCountrySelect(option);
                      }}
                    />
                  </div>
                  :
                  <TextInput
                    ref='postalCode'
                    className={'textInputAccordian ' + (isInternational && isCountryEmpty ? 'benTxtInputError' : '')}
                    placeholder={isInternational ?
                      messages['app.payment.country'] :
                      messages['app.payment.beneDetail.postalCode']}
                    onChange={postalCode => this.setState({ postalCode: postalCode.target.value })}
                    style={StyleSheet.flatten(styles.inputSpacing)}
                    value={postalCode}
                    id="input_beneficiaryDetails_postalCode_paymentAddBeneficiary_test"
                  // onFocus={() => this.scrollLayout(380)}
                  />
                }
                <div className="srchBankBtn">
                  <Button
                    testID="btn_beneficiaryDetails_searchBank_paymentAddBeneficiary_test"
                    size="normal"
                    style={styles.setBottom}
                    disabled={!isSearchEnable}
                    onPress={() => isSearchEnable ? this.getBankDetails('SEARCH') : ''}
                  >
                    {messages['app.payment.beneDetail.searchBank']}
                  </Button>
                </div>
              </div>}
          </div>}

        {/* {(envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic')) && <div className="row" >
          <div className="columns large-1 large-6">
             <Large style={StyleSheet.flatten(styles.label)}>{messages['app.payment.beneDetail.sortcodeLabel']}</Large>
             {!isIBANSelected &&  <span style={StyleSheet.flatten(styles.asteriskStyle)}>*</span>}
            <TextInput
              inputmode="numeric"
              ref='sortCode'
              className="textInputAccordian"
              placeholder={messages['app.payment.beneDetail.sortcode']}
              // pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
              maxlength= {isSixDigitSortCode ? 6 : 8}
              onSubmitEditing={(event) => { this.refs.textRef.blur(); }}
              onChange={(e) => this.onChange(e)}
              value={sortCode}
              id="input_beneficiaryDetails_sortCode_paymentAddBeneficiary_test"
              style={{borderColor:'grey'}}
              disabled={ isIBANSelected ? true : false}
            // onFocus={(e) => this.scrollLayout(180)}
            />
            { !sortCodeValue && <Text secondary style={{ 'color': 'red' }}>{"Please enter a valid sort code format"}</Text>}
          </div>
          </div>
        } */}
      </View>
    );

  };
  handleIbanSearch = (enableIbanBtn, isValidName) => {
    if (!isValidName) return this.setState({ checkBeneficiaryName: true })
    if (enableIbanBtn) this.getBankDetails('IBAN')
  }
  onChangeBeneficiaryName = async (name) => {
   
    const { target: { value } } = name;
     

    const { payments: { setSelectedBeneficiaryBank, setAccountMatchType, resetDuplicateItem, setExistingBeneficiaryId, setAccountTypeNoMatchType } } = this.props;

    this.setState({
      beneficiaryName: value,
      checkBeneficiaryName: true,
      isBeneficiaryValidated: false
    });
    await setSelectedBeneficiaryBank('');
    await resetDuplicateItem();
    await setExistingBeneficiaryId(null);
    await setAccountMatchType('');
    await setAccountTypeNoMatchType('');
  }

  // Function to replace new beneficiary with the existing beneficiary
  replaceExistingBeneficiary = async () => {
    await this.props.payments.resetDuplicateItem();
    this.validateBeneficiary();

  }

  // Function to close the duplicate beneficiary modal
  closeBenfDuplicateModal = async () => {
    const { setSelectedBeneficiaryBank, setExistingBeneficiaryId } = this.props.payments;
    await setSelectedBeneficiaryBank('');
    this.props.payments.resetDuplicateItem();
    setExistingBeneficiaryId(null);
    this.setState({isBeneficiaryValidated: false });
  }

  // Modal to check Duplicate Beneficiary or not
  renderDuplicateBenfModal = () => {
    const { i18n: { messages }, payments: { isIBANSelected, paymentType, duplicateItem } } = this.props;
    const item = duplicateItem;

    return (
      <React.Fragment>
      <Modal
        isActive={this.props.payments.duplicateModal}
        style={styles.modalstyle}
        onClose={this.closeBenfDuplicateModal}
        className="beneficiary-duplicate-modal"
        header={messages['app.payment.beneficiary.duplicate.modal.title']}
        content={
          <View>
            { ((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion=== RM_REGION_UK ) && paymentType.includes('domestic')) && !isIBANSelected ?
              <div className="padding-20">
              <div style={StyleSheet.flatten(styles.PT10)} tabIndex={0}>
                {messages['app.payment.CoP.beneficiary.ExistingBeneficiary.Label']}
              </div>
              
              <div style={StyleSheet.flatten(styles.PT10)}>
                {messages['app.payment.beneficiary.duplicate.replace']}
              </div>
              <div className="text-right margin-top-20">
                <Button
                  tertiary
                  className="cancelButton"
                  onPress={this.closeBenfDuplicateModal}
                  size="large"
                >
                  {messages['app.common.alert.no']}
                </Button>

                <Button
                  onPress={this.replaceExistingBeneficiary}
                  size="large">
                  {messages['app.common.alert.yes']}
                </Button>
              </div>
            </div>
             :
            <div className="padding-20">
             <Text>{messages['app.payment.beneficiary.duplicate']}</Text>
             <div className="padding-top-20 padding-bottom-20">
             <div>{item.firstName + ' ' + (item.lastName ? item.lastName : '')}</div>
               <div>{item.address1}{item.address1 && item.address2 ? "-" : ""}{item.address2}</div>
               <div>{item.address3}</div>
                <div>{messages['app.common.portfolio.bonds.account']}{":"}{item.accountNo ? item.accountNo : item.ibanNo}</div>
               <div>{item.bank}{paymentType.includes(PAYMENT_TYPE.domestic) ? (item.ntnlId ? (' (' + item.ntnlId + ')') : '') : (item.swiftCode ? (' (' + item.swiftCode + ')') : '')}</div>
               <div>{item.cityName}{item.cityName && item.postalCode ? ',' : ''}{item.postalCode}{item.country ? "-" : ""}{item.country}</div>
             </div>
             <div>{messages['app.payment.beneficiary.duplicate.replace']}</div>
             <div className="text-right margin-top-20">
               <Button
                 tertiary
                 onPress={this.closeBenfDuplicateModal}
                 size="large">
                 {messages['app.common.alert.no']}
               </Button> 
               <Button
                 onPress={this.replaceExistingBeneficiary}
                 size="large">
                 {messages['app.common.alert.yes']}
               </Button>
             </div>
             </div>
             }
          </View>
        }
      />
    </React.Fragment>
    )
  }

  renderErrorModal = () => {
    const { payments: { errorMsg } } = this.props;
    return(
      <Modal
      className="error-modal-focus"
      isActive
      onClose={() => this.props.payments.setErrorModal(false)}
      content={
        <div className="small-12 row padding-20">
          <div className="column small-1">
            <ErrorIcon width={30} height={30} />
          </div>
          <div className="column small-11">
            <Text secondary>{errorMsg}</Text>
          </div>
        </div>
      }
    />
    )
  }

  componentWillReceiveProps = async (nextProps) => {
    const {
      payments: {
        errorIBANMsg,
        selectedBeneficiaryBank,
      }
    } = nextProps;

    const { setSelectedBeneficiaryBank } = this.props.payments;
    const { isBeneficiaryValidated } = this.state;

     if(!errorIBANMsg && selectedBeneficiaryBank && isBeneficiaryValidated === false) {
      await setSelectedBeneficiaryBank(selectedBeneficiaryBank);
      this.validateBeneficiary();
      this.setState({isBeneficiaryValidated: true});
    }
  }

  componentDidUpdate(){
    if(document.querySelector('.beneficiary-duplicate-modal .button--tertiary')){ //Dulpicate beneficiary warning popup
      document.querySelector('.beneficiary-duplicate-modal .button--tertiary').focus();
    }
    if(document.querySelector('div H3')){ //Search country list popup optional address field
      document.querySelector('div H3').focus();
    }
    if(document.querySelector('.focusSearchDestBank')){ 
      document.querySelector('.focusSearchDestBank').focus();
    }    
  }


  componentDidMount = async () => {
    const { payments: { isIBANSelected, selectedBeneficiaryBank, selectedBeneficiaryDetail, setIBAN, paymentType, setExistingBeneficiaryId, setBeneficiaryIdToUpdate } } = this.props;

    this.props.payments.setSearchBankLoading(false);
    setExistingBeneficiaryId(null);
    setBeneficiaryIdToUpdate(null);
    let countrySelected = '';
    if(selectedBeneficiaryDetail && selectedBeneficiaryDetail.country) {
      const countryNameArray = selectedBeneficiaryDetail.country.split(" ");
      let i;
      for(i=0; i<countryNameArray.length; i++) {
        countrySelected += capitalize(countryNameArray[i]);
        if(countryNameArray[i+1] != undefined) {
          countrySelected += " ";
        }
      }
    }
    this.setState({countrySelected});


    // set default IBANselected to false for UK Domestic Payments.
    if ((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic)) {
      if(selectedBeneficiaryBank == (null || undefined)) {
        await setIBAN(false);
      }

    }
    if (selectedBeneficiaryBank != null) {
      let formattedAccountNo;
      if (!isEmpty(selectedBeneficiaryBank.accountNo)) {
        formattedAccountNo = selectedBeneficiaryBank.accountNo.replace(/(.{4})/g, '$1 ').trim();
        this.setState({ accountNumber: selectedBeneficiaryBank.accountNo, formattedAcntNumber: formattedAccountNo });
      } else {
        formattedAccountNo = selectedBeneficiaryBank.ibanNo.replace(/(.{4})/g, '$1 ').trim();
        this.setState({ accountNumber: selectedBeneficiaryBank.ibanNo, formattedAcntNumber: formattedAccountNo });
      }
      this.setState({
        beneficiaryName: selectedBeneficiaryBank.beneficiaryName || (selectedBeneficiaryBank.firstName || '') + (selectedBeneficiaryBank.firstName && selectedBeneficiaryBank.lastName ? ' ' : '') + (selectedBeneficiaryBank.lastName || ''),
        bankName: selectedBeneficiaryBank.bank,
        city: selectedBeneficiaryBank.city || selectedBeneficiaryBank.cityName,
        clearingNumber: selectedBeneficiaryBank.ntnlId,
        postalCode: selectedBeneficiaryBank.postalCode,
        streetName: selectedBeneficiaryBank.address1,
        zipCode: selectedBeneficiaryBank.address2,
        country: selectedBeneficiaryBank.address3,
        accountType: selectedBeneficiaryBank.accountType || selectedBeneficiaryBank.businessType
      });

      if ((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) && !isIBANSelected) {
        let formattedSortCode = selectedBeneficiaryBank.sortCode || selectedBeneficiaryBank.ntnlId;
        if(formattedSortCode != null) {
          if(formattedSortCode.length == 5) {
            formattedSortCode = `0${formattedSortCode}`;
          }
          if(formattedSortCode.length == 6) {
            formattedSortCode = formattedSortCode.replace(/(.{2})/g, '$1-').trim();
            formattedSortCode = formattedSortCode.slice(0,formattedSortCode.length-1);
          }
        }
        this.setState({ sortCode: formattedSortCode});
      }
    }
  }

  // CoP Match details
  renderCoPMatchDetails = () => (
    <AccordionItem
      className="PaymentMatch"
      renderTitle={this.renderCoPMatchHeader()}
      itemKey={1}
      key={1}
    />
  )

  // CoP No Match Details
  renderCoPNoMatchDetails = () => (
    <View>
        <Accordion
          renderIconForOpen={() => <ChevronDown className="downArrow" width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />}
          renderIconForClose={() => <ArrowRight color='#010E28' width={WARNING_ICON.width} height={WARNING_ICON.height} />}
          fullWidth
          onChange={(activeCoPItems) => { this.setState({ CoPaccordionNoMatchActive: activeCoPItems }) }}
          activeItems={this.state.CoPaccordionNoMatchActive}
          style={{
            border: 'none',
          }}
        >
          <AccordionItem
            className="PaymentNoMatch"
            renderTitle={this.renderCoPNoMatchHeader()}
            itemKey={1}
            key={1}
          >
            {this.renderCoPNoMatchContent()}
          </AccordionItem>
        </Accordion>
      </View>
  )

  // CoP Not Applicable Details
  renderCoPNotApplicable = () => (
    <View>
      <Accordion
          renderIconForOpen={() => <ChevronDown className="downArrow" width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />}
          renderIconForClose={() => <ArrowRight color='#010E28' width={WARNING_ICON.width} height={WARNING_ICON.height} />}
          fullWidth
          onChange={(activeCoPItems) => { this.setState({ CoPaccordionNotApplicableActive: activeCoPItems }) }}
          activeItems={this.state.CoPaccordionNoMatchActive}
          style={{
            border: 'none',
          }}
        >
        <AccordionItem
          className="PaymentPartialMatch"
          renderTitle={this.renderCoPNotApplicableHeader()}
          itemKey={1}
          key={1}
        >
          {this.renderCoPNotApplicableContent()}
        </AccordionItem>
      </Accordion>
    </View>
  )

  // CoP Account Type No Match
  renderCoPAccountTypeNoMatch = () => (
    <View>
      <AccordionItem
        className="PaymentPartialMatch"
        renderTitle={this.renderAccountTypeNoMatchHeader()}
        itemKey={1}
        key={1}
      >
      </AccordionItem>
    </View>
  )

  // CoP Partial Match 
  renderCoPPartialMatchDetails = () => (
      <View>
        <Accordion
          renderIconForOpen={() => <ChevronDown className="downArrow" width={WARNING_ICON.width} height={WARNING_ICON.height} color='#010E28' />}
          renderIconForClose={() => <ArrowRight color='#010E28' width={WARNING_ICON.width} height={WARNING_ICON.height}/>}
          fullWidth
          onChange={(activeCoPItems) => { this.setState({ CoPaccordionPartialMatchActive: activeCoPItems }) }}
          activeItems={this.state.CoPaccordionPartialMatchActive}
          style={{
            border: 'none',
          }}
        >
          <AccordionItem
            className="PaymentPartialMatch"
            renderTitle={this.renderCoPPartialMatchHeader()}
            itemKey={1}
            key={1}
          >
            {this.renderCoPPartialMatchContent()}
          </AccordionItem>
        </Accordion>   
      </View>
    )

  validateBeneficiary = async() => {
    const { payments: { beneficiaryIdToUpdate, paymentType, isIBANSelected, selectedBeneficiaryBank, validateBeneficiary, existingBeneficiaryId, setExistingBeneficiaryId } } = this.props;
    const { accountType } = this.state;
    const bankRefId = selectedBeneficiaryBank.bankRefId;

    const modifiedSelectedBeneficiaryBank = this.getSelectedBenf();

    const beneficiaryDetails = {
      paymentType,
      beneficiaryName: modifiedSelectedBeneficiaryBank.beneficiaryName,
		  firstName: modifiedSelectedBeneficiaryBank.firstName,
		  lastName: modifiedSelectedBeneficiaryBank.lastName,
		  accountNo: modifiedSelectedBeneficiaryBank.accountNo,
      accountType: accountType,
      bankRefId,
      address: {
        address1: modifiedSelectedBeneficiaryBank.address1,
        address2: modifiedSelectedBeneficiaryBank.address2,
        address3: modifiedSelectedBeneficiaryBank.address3,
        cityName: modifiedSelectedBeneficiaryBank.city,
        country: modifiedSelectedBeneficiaryBank.country,
        postalCode: modifiedSelectedBeneficiaryBank.postalCode,
      }
    }

    if(modifiedSelectedBeneficiaryBank.beneficiaryId) {
      beneficiaryDetails.beneficiaryId = modifiedSelectedBeneficiaryBank.beneficiaryId;
    }

    if(isIBANSelected) {
      beneficiaryDetails.ibanNo = modifiedSelectedBeneficiaryBank.ibanNo;
      beneficiaryDetails.accountNo =  null
    }

    if(existingBeneficiaryId) {
      beneficiaryDetails.beneficiaryId = existingBeneficiaryId;
    }
    if(beneficiaryIdToUpdate) {
      beneficiaryDetails.beneficiaryId = beneficiaryIdToUpdate;
    }
    setExistingBeneficiaryId(null);
    await validateBeneficiary(beneficiaryDetails);

    // to Keep CoP accordion Open if closed by user in last CoP Validate Call
    this.setState({
      CoPaccordionPartialMatchActive: [1],
      CoPaccordionNoMatchActive: [1],
      CoPaccordionNotApplicableActive: [1]
    });
    
  }

  render() {
    const {
      i18n: { messages },
      payments: {
        beneficiaryList,
        isIBANSelected,
        bankList,
        isPymtEditBenef,
        selectedBeneficiaryBank,
        errorIBANMsg,
        errorSortCodeMsg,
        countryList,
        paymentType,
        errorMsgs,
        IBANSegError,
        selectedCurrency, 
        accountMatchType,
        searchBankLoading,
        accountTypeNoMatchType,
        isPymtEditFrmCaptureScreen
      },
    } = this.props;
    const {
      beneficiaryName,
      accountNumber,
      searchBankModal,
      checkBeneficiaryName,
      formattedAcntNumber,
      streetName,
      zipCode,
      sortCodeValue,
      sortCode,
      isValidAccountNo,
      accountType,
      isBeneficiaryValidated
    } = this.state;
    const enableIbanBtn = !selectedBeneficiaryBank && isIBANSelected && !isEmpty(beneficiaryName) && !isEmpty(formattedAcntNumber);
    const isSepa = paymentType.includes('sepa')
    const isValidName = validateBenefName(beneficiaryName)
    const showAlertName = checkBeneficiaryName && !isValidName

    const isInternational = paymentType.includes(PAYMENT_TYPE.international);

    const isCountryEmpty = (selectedBeneficiaryBank && isCanadian(selectedBeneficiaryBank.country) || (selectedCurrency && selectedCurrency.tech === CANADIAN_COUNTRY.currencyCode)) ? !isEmpty(this.state.country) : isCanadian(this.state.country);

    const addressFields = isCountryEmpty && !isEmpty(streetName) && !isEmpty(zipCode);

    const enableCtnBtn = (isInternational && ((selectedBeneficiaryBank && isCanadian(selectedBeneficiaryBank.country)) || (selectedCurrency && selectedCurrency.tech === CANADIAN_COUNTRY.currencyCode)
      || isCanadian(this.state.country)) ? addressFields : true);

    const CheckValidation =  !isEmpty(formattedAcntNumber) && (validateBenefName(beneficiaryName) && !isEmpty(beneficiaryName))
    const re = /[0-9]{2}(?:-[0-9]{2})(?:-[0-9]{2})/;
    const regexForSixDigit = new RegExp("^[0-9]{6,6}$");
    const isSixDigitSortCode = regexForSixDigit.test(sortCode);
    const checkSortCode = (envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic') && !isIBANSelected ) ? (re.test(sortCode) || isSixDigitSortCode) ? true : false : true;
    const checkAccountType = (envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic') && !isIBANSelected) ? !accountType ? false : true : true;
    const isValidBeneficiary = validateBenefName(beneficiaryName) && !isEmpty(accountNumber) && selectedBeneficiaryBank && enableCtnBtn && checkSortCode;

    if (searchBankLoading) {
      return <View style={StyleSheet.flatten(styles.destActivityLoader)}>
          <ActivityIndicator
            style={StyleSheet.flatten(styles.activityLoader)}
            animating
            color={PALETTE.primaryText}
            size="large"
          />
        </View>
    }

    return (

      
      <View className="payment-page row">
        <ScrollTopOnMount />
        <div>{errorMsgs && <PaymentError errors={errorMsgs} />}</div>
        <div className="title">
          <H1 secondary tabIndex={0}>{messages['app.payment.pageTitle.beneDetail']}</H1>
        </div>
        { ((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion=== RM_REGION_UK ) && !isIBANSelected && paymentType.includes('domestic')) &&
          
          <View>
            { accountTypeNoMatchType === CoP.ACCOUNT_TYPE_NO_MATCH && this.renderCoPAccountTypeNoMatch() }

            { accountMatchType === CoP.PARTIAL_MATCH && this.renderCoPPartialMatchDetails()}

            { accountMatchType === CoP.MATCH && this.renderCoPMatchDetails()}

            { accountMatchType === CoP.NO_MATCH && this.renderCoPNoMatchDetails() }

            { accountMatchType === CoP.NOT_APPLICABLE && this.renderCoPNotApplicable() }

            { accountMatchType === CoP.ACCOUNT_TYPE_NO_MATCH && this.renderCoPAccountTypeNoMatch() }
            
          </View>
        }
        { this.renderBeneficiaryConfirmModal() }
        <div testID="payment-beneficiary">
          <View>
            <View style={styles.beneNameField}>
            { ((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion=== RM_REGION_UK ) && paymentType.includes('domestic')) &&
              <div className='row' style={StyleSheet.flatten(styles.PT10)}>
                <div className='columns' style={StyleSheet.flatten(styles.autoWidth)} >
                  <Large style={StyleSheet.flatten(styles.label)} tabIndex={0}>
                    {messages['app.CoP.label.beneficiary.account.type']}
                  </Large>
                  {!isIBANSelected && <span style={StyleSheet.flatten(styles.accountTypeAsterick)}>*</span> }
                </div>

            
                <div className='columns autoWidth' style={StyleSheet.flatten([styles.autoWidth])} aria-label={messages['app.CoP.label.person']}>
                  <Radio
                    checked={accountType === CoP.PERSON}
                    disabled={isIBANSelected}
                    onChange={() => this.onBusinessTypeSelected(CoP.PERSON)}
                  />
                  <span style={StyleSheet.flatten(styles.radioLabel)}>{messages['app.CoP.label.person']}</span>
                </div>

                <div className='columns' style={StyleSheet.flatten(styles.autoWidth)} aria-label={messages['app.CoP.label.business']}>
                  <Radio
                    checked={accountType === CoP.BUSINESS}
                    disabled={isIBANSelected}
                    onChange={() => this.onBusinessTypeSelected(CoP.BUSINESS)}
                  />
                  <span style={StyleSheet.flatten(styles.radioLabel)}>{messages['app.CoP.label.business']}</span>
                </div>
                  
                <div className='columns' style={StyleSheet.flatten([styles.autoWidth, styles.floatNone])} aria-label={messages['app.orderReport.infoIcon']}>
                  <Popover
                    mode="popup"
                    orientation="left"
                    position={50}
                    showOnHover
                    arrowColor={PALETTE.secondaryActive}
                    popOverClassName="businessAccountType-popover"
                    content={
                      <div testID={`popover_text_CoP_account_type_test`}>
                        <p>{messages['app.payment.CoP.Label.AccountType.Label1']}</p>
                        <p>{messages['app.payment.CoP.Label.AccountType.Label2']}</p>
                      </div>
                    }
                    >
                    <Info2 color={PALETTE.fordGray} height={29} width={29} />
                  </Popover>
                </div>

              </div>
              }
              <div style={StyleSheet.flatten(styles.PT10)}>
                <Large style={StyleSheet.flatten([styles.label, styles.paddignTop10])} tabIndex={0}>
                  {messages['app.payment.beneDetail.beneficiaryFullName']}
                </Large>
                <span style={StyleSheet.flatten(styles.asteriskStyle)}>*</span>
              </div>
              <div className="row">
                <div className="columns large-1 large-6">
                  <TextInput
                    id="input_beneficiaryDetails_name_paymentAddBeneficiary_test"
                    ref='textRef'
                    className={'benTxtInput textInputAccordian' + (showAlertName ? ' benTxtInputError' : '')}
                    placeholder={messages['app.payment.beneDetail.enterBeneficiaryFullName']}
                    maxLength={35}
                    onChange={this.onChangeBeneficiaryName}
                    style={StyleSheet.flatten(styles.inputSpacing)}
                    value={beneficiaryName}
                  />
                  </div>
                  <div className='columns large-1 large-1' style={StyleSheet.flatten(styles.PT15)} aria-label={messages['app.orderReport.infoIcon']}>
                    {((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion=== RM_REGION_UK ) && !isIBANSelected && paymentType.includes('domestic')) && 
                      <Popover
                        mode="popup"
                        orientation="right"
                        position={50}
                        arrowColor={PALETTE.secondaryActive}
                        popOverClassName="beneficiaryName-popover"
                        content={
                          <div testID={`popover_text_CoP_benef_name_test`}>
                            {messages['app.payment.CoP.Label.accountMatchInstruction']}
                          </div>
                        }
                      >
                        <Info2 color={PALETTE.fordGray} height={29} width={29} />
                      </Popover>
                    }
                      
                </div>
                <div className='columns large-1 large-5' />
              </div>

            </View>

                <View>
                  <Accordion
                    renderIconForOpen={() => <AccordionMinusIcon/>}
                    renderIconForClose={() => <AccordionPlusIcon aria-label={messages['app.payment.expandAddress']} role="button"/>}
                    fullWidth
                    onChange={(activeItems) => { this.setState({ accordionActive: activeItems }) }}
                    activeItems={this.state.accordionActive}
                    style={{
                      border: 'none',
                    }}
                  >
                    <AccordionItem
                      renderTitle={this._renderHeader}
                      itemKey={1}
                      key={1}
                      // className={}
                      style={{
                        border: 'none',
                      }}
                    >
                      {this._renderContent()}
                    </AccordionItem>
                  </Accordion>
                </View>
                
            <View style={styles.beneNameField}>
              <View>
                <span>
                  <Large style={StyleSheet.flatten(styles.label)} tabIndex={0}>{isSepa ?
                    messages['app.payment.beneDetail.ibanFormat'] :
                    messages['app.payment.beneDetail.accountNumber']}
                  </Large>
                  <span style={StyleSheet.flatten(styles.asteriskStyle)}>*</span>
                </span>
                <div className="row">
                  <div className="columns large-1 large-6" id="textbox_accountNumberPayment_paymentAddBeneficiary_test">
                    <TextInput
                      ref='textRef'
                      className="textInputAccordian"
                      placeholder={(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion=== RM_REGION_UK ) && paymentType.includes('domestic') && !isIBANSelected ? messages['app.payment.beneDetail.placeholder.8digitaccountNumber'] : messages['app.payment.beneDetail.accountNumber']}
                      maxLength={((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion=== RM_REGION_UK ) && paymentType.includes('domestic') && !isIBANSelected) ? 9 :43}
                      // maxLength={47}
                      onChange={(newAccountNumber) => this.changeAccNumber(newAccountNumber)}
                      style={StyleSheet.flatten(styles.inputSpacing)}
                      value={formattedAcntNumber}
                    // onFocus={() => this.scrollLayout(150)}
                    />
                  </div>
                  <div className="columns large-1 large-6" style={StyleSheet.flatten(styles.MT4)}>
                    {!isSepa &&
                    <View style={StyleSheet.flatten(styles.checkBoxWrapper)}>
                      <Checkbox
                        onChange={() => this.handleIbanCheckbox()}
                        checked={isIBANSelected}
                        testID="checkbox_accountNumberPayment_paymentAddBeneficiary_test"
                        aria-label={messages['app.payment.ibanCheckbox']}
                      />
                      <Text style={StyleSheet.flatten(styles.labelCheck)}>{messages['app.payment.beneDetail.ibanLabel']}</Text>
                    </View>}
                  </div>
                </div>

                {!isValidAccountNo && accountNumber.length !==0 &&!isIBANSelected && (envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic')) && this.renderInvalidAccountErrorMsg()}

                {isIBANSelected && errorIBANMsg != '' && errorIBANMsg != null && errorIBANMsg != undefined && this.renderErrorMsg()}
              </View>
              

                {(envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic')) && 
                  <div>
                    <span style={{marginTop:20}}>
                      <Large style={StyleSheet.flatten(styles.label)} tabIndex={isIBANSelected?-1:0}>{messages['app.payment.beneDetail.sortcodeLabel']}</Large>
                      {!isIBANSelected &&  <span style={StyleSheet.flatten(styles.asteriskStyle)}>*</span>}
                    </span>
                    <div className="row" >
                      <div className="columns large-1 large-6">
                        
                        <TextInput
                          inputmode="numeric"
                          ref='sortCode'
                          className={"textInputAccordian" + (!checkSortCode && !isIBANSelected && sortCode.length!==0 ? ' benTxtInputError' : '')}
                          placeholder={messages['app.payment.beneDetail.placeholder.sortcode']}
                          // pattern="[0-9]{2}-[0-9]{2}-[0-9]{2}"
                          maxlength= {isSixDigitSortCode ? 6 : 8}
                          onSubmitEditing={(event) => { this.refs.textRef.blur(); }}
                          onKeyUp={(e) => this.onKeyUpSortCode(e)}
                          value={isIBANSelected ? '' : sortCode}
                          id="input_beneficiaryDetails_sortCode_paymentAddBeneficiary_test"
                          style={{borderColor:'grey'}}
                          disabled={isIBANSelected }
                          
                        // onFocus={(e) => this.scrollLayout(180)}
                        />
                        { !isIBANSelected && errorSortCodeMsg != '' && errorSortCodeMsg != null && errorSortCodeMsg != undefined && this.renderErrorMsg()}
                      </div>
                    </div>
                  </div>

            }

            </View>
            {this._renderDestinationBank()}
            {this.renderCountryModal(countryList, messages)}
            {this.props.payments.duplicateModal && this.renderDuplicateBenfModal()}
            {this.props.payments.errorModal && this.renderErrorModal()}
          </View>
        </div>

        {((!selectedBeneficiaryBank && isIBANSelected) || IBANSegError) && (envConfig.envConfig !== EBANKINGWEBUK || !(paymentType.includes('domestic'))) &&
          <div className="cntBtn" testId="search-bank-by-iban-no">
            <div>
              <Button
                size="medium"
                disabled={CheckValidation ? false : true}
                onPress={() => this.handleIbanSearch(enableIbanBtn, isValidName)}>
                {messages['app.CoP.label.validateBeneficiary']}
              </Button>
            </div>
          </div>}

        {!(!selectedBeneficiaryBank) && !IBANSegError && 
          <div className="cntBtn">
            <div>
              <Button
                size="medium"
                className={!(CheckValidation && checkSortCode) ? 'disableButton' : ''}
                // disabled={!isValidBeneficiary} // will come on international payment or  when we click on new bank search , sortcode field not there 
                disabled={!(isValidName  && CheckValidation && checkSortCode && checkAccountType && accountMatchType !== CoP.ACCOUNT_TYPE_NO_MATCH && !accountTypeNoMatchType)}
                // onPress={() => isValidBeneficiary ?  this.navigateToForm() :  this.setState({ checkBeneficiaryName: true })}>
                   onPress={() => this.addBeneficiary()}>
                 
                  { messages['app.CoP.label.confirmBeneficiary'] } 
              </Button>
            </div>
          </div>}
          { (!isBeneficiaryValidated) && (!selectedBeneficiaryBank) && envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic') && 
            <div className="cntBtn">
            <div>
              <Button
                size="medium"
                disabled={!(isValidName  && CheckValidation && checkSortCode && isValidAccountNo && checkAccountType)}
                onPress={() => this.getBankDetails('IBAN')}>
               { messages['app.CoP.label.validateBeneficiary'] }
              </Button>
            </div>
          </div>
          }
          {
          // (searchBankModal && selectedBeneficiaryBank && (selectedBeneficiaryBank.avaloqBankId || selectedBeneficiaryBank.bankRefId) && envConfig.envConfig === EBANKINGWEBUK && paymentType.includes('domestic')) ?
          //     this.navigateToForm(): searchBankModal && this._renderSearchModal(bankList)
            searchBankModal && this._renderSearchModal(bankList)
          }
      </View>
    );
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    replacePage: { $call: 'ui.history.replace' },
    changePage: { $call: 'ui.history.push' },
    changeStateTitle: { $call: 'ui.change.customtitle' },
    payments: {
      IBANSegError: true,
      paymentType: true,
      beneficiaryList: true,
      bankList: true,
      errorIBANMsg: true,
      errorSortCodeMsg: true,
      selectedBeneficiaryBank: true,
      setSelectedBeneficiaryBank: { $set: 'selectedBeneficiaryBank' },
      setSelectedBeneficiaryDetail: { $set: 'selectedBeneficiaryDetail' },
      isIBANSelected: true,
      setIBAN: { $set: 'isIBANSelected' },
      existingBeneficiaryId: true,
      setExistingBeneficiaryId: { $set: 'existingBeneficiaryId' },
      getBankAccountDetails: { $call: 'searchBankDetails' },
      getSearchCountryData: { $call: 'searchCountry' },
      searchBankLoading: true,
      setSearchBankLoading: { $set: 'searchBankLoading' },
      countryList: true,
      selectedBank: true,
      setSelectedBank: { $set: 'selectedBank' },
      clearIBNErrorMsg: { $set: 'errorIBANMsg' },
      clearSortCodeErrorMsg: { $set: 'errorSortCodeMsg'},
      isPymtAddNewBenef: true,
      beneficiaryIdToUpdate: true,
      setBeneficiaryIdToUpdate: { $set: 'beneficiaryIdToUpdate'},
      setIsPymtAddNewBenef: { $set: 'isPymtAddNewBenef' },
      allCountryList: true,
      noRecordsFound: true,
      errorMsgs: true,
      setErrorMsg: { $set: 'errorMsgs' },
      selectedCurrency: true,
      addNewBeneficiary: { $call: 'addNewBeneficiary' },
      errorMsg: true,
      errorModal: true,
      setErrorModal: { $set: 'errorModal'},
      isPymtEditBenef: true,
      setIsPymtEditBenef: { $set: 'isPymtEditBenef'},
      editBeneficiary: { $call: 'editBeneficiary' },
      isPymtEditFrmCaptureScreen: true,
      duplicateModal: true,
      duplicateItem : true,
      resetDuplicateItem: { $call: 'resetDuplicateItem'},
      setIsPymtEditFrmCaptureScreen: { $set: 'isPymtEditFrmCaptureScreen'},
      selectedBeneficiaryDetail: true,
      loading: true,
      validateBeneficiary: { $call: 'validateBeneficiary'},
      accountMatchType: true,
      CoPAccountNameMatched: true,
      setAccountMatchType: { $set: 'accountMatchType'},
      accountTypeNoMatchType: true,
      setAccountTypeNoMatchType: { $set: 'accountTypeNoMatchType' }
    }
  },
})(PymtBenefadd);
